import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { createBrowserHistory } from 'history';
import rootReducer from '../reducers/root.reducer';
import apiSaga from '../saga/api.saga';
import appSaga from '../saga/app.saga';
import assetViewerSaga from '../saga/assetViewer.saga';
import authSaga from '../saga/auth.saga';
import cmsSaga from '../saga/cms.saga';
import posSaga from '../saga/pos.saga';
import ppcSaga from '../saga/ppc.saga';
import settingsSaga from '../saga/settings.saga';
import usersSaga from '../saga/users.saga';

const saga = createSagaMiddleware();

export const history = createBrowserHistory();

export const mainStore = ({ initialState = {} } = {}) => {
	const store = createStore(
		rootReducer,
		initialState,
		composeWithDevTools(applyMiddleware(saga)),
	);

	saga.run(apiSaga);
	saga.run(appSaga);
	saga.run(assetViewerSaga);
	saga.run(authSaga);
	saga.run(cmsSaga);
	saga.run(posSaga);
	saga.run(ppcSaga);
	saga.run(settingsSaga);
	saga.run(usersSaga);

	return store;
};